import BottomTab from "./BottomTab";
import Breadcrumb from "./Breadcrumb";

const EXPORT = {
  BottomTab,
  Breadcrumb,
};

export default EXPORT;
